<div class="pointContainer" #pointer>
  @if (position != null) {
    <div class="point" [ngClass]="role == userRole.Expert ? 'expert' : 'technician'" [ngStyle]="{'top.px': position.y, 'left.px': position.x }"></div>
  }
</div>
